export const SALES_CHANNELS = {
    dom: 'DOM',
    lgp: 'LGP',
    gov: 'GOV',
    univ: 'UNIV'
};

export const normalizeSalesChannel = salesChannel =>
    (salesChannel || SALES_CHANNELS.dom).toUpperCase();

const APPROVAL_SALES_CHANNELS = [
    SALES_CHANNELS.lgp,
    SALES_CHANNELS.gov,
    SALES_CHANNELS.univ
];

const isApprovalSalesChannel = salesChannel =>
    APPROVAL_SALES_CHANNELS.includes( normalizeSalesChannel( salesChannel ) );

export const isLgpAdminCustomer = ( {account, isAdmin} = {} ) =>
    isAdmin === true &&
    [SALES_CHANNELS.lgp, SALES_CHANNELS.gov].includes( normalizeSalesChannel( account?.salesChannel ) );

export const shouldUseOrderApprovalPath = ( {account, cart} = {} ) =>
    cart?.approvalRequired === true && isApprovalSalesChannel( account?.salesChannel );

export const shouldRequirePONumber = ( {account, cart, isPunchOut} = {} ) => {
    return !isPunchOut &&
        isApprovalSalesChannel( account?.salesChannel ) &&
        !shouldUseOrderApprovalPath( {account, cart} );
};

export const shouldRestrictApprovalNonAdminCheckoutOptions = ( {
                                                                  account,
                                                                  isAdmin,
                                                                  ordersNeedApproval
                                                              } = {} ) =>
    isApprovalSalesChannel( account?.salesChannel ) &&
    isAdmin !== true &&
    Boolean( ordersNeedApproval ) &&
    ordersNeedApproval !== 'Never';

export const shouldRestrictApprovalPaymentOptions = customerData =>
    shouldRestrictApprovalNonAdminCheckoutOptions( customerData ) &&
    !(customerData.ordersNeedApproval === 'IfOrderTotalIsAboveLimit' &&
        customerData.cart?.approvalRequired === false);

export const shouldRequirePaymentValidation = customerData =>
    !customerData?.isPunchOut &&
    customerData?.cart?.approvalRequired !== true &&
    !shouldRestrictApprovalPaymentOptions( customerData );
